import { render } from "./4VisiMisi.vue?vue&type=template&id=50c9132f"
import script from "./4VisiMisi.vue?vue&type=script&lang=js"
export * from "./4VisiMisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__